import React, { FC } from 'react';
import AssessmentTemplateSettings from '../components/assessment_template_settings/assessment_template_settings';

const ProjectTemplateSettings: FC = () => {
    return <AssessmentTemplateSettings />;
};

export default ProjectTemplateSettings;
